import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import Home from "./Home";
import Gallery from "./Gallery";
import Shop from "./Shop";
import Contact from "./Contact";
import Cart from "./Cart";
import MaterialsPage from "../pages/MaterialsPage";
import BankTransferPage from "../pages/BankTransferPage";

import AdminPanel from "./AdminPanel";    // poprawne
import AdminLogin from "../pages/AdminLogin";

import RegulaminPageEn from "../pages/RegulaminPageEn";
import PrivacyPageEn from "../pages/PrivacyPageEn";
import RodoPageEn from "../pages/RodoPageEn";

import RegulaminPage from "../pages/RegulaminPage";
import PrivacyPage from "../pages/PrivacyPage";
import RodoPage from "../pages/RodoPage";

import { useCart } from "../CartContext";

export default function Layout({ lang, setLang }) {
  const location = useLocation();
  const navigate = useNavigate();     // ← konieczne! (poprawia błędy z navigate)
  const path = location.pathname;

  const { cart } = useCart();
  const cartCount = cart.reduce((sum, item) => sum + (item.qty || 1), 0);

  const [menuOpen, setMenuOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  // odczytaj status zalogowania admina
  useEffect(() => {
    const saved = localStorage.getItem("adminLogged");
    setIsAdmin(saved === "1");
  }, []);

  // *** bardzo ważne – przekazujemy setIsAdmin do AdminLogin ***
  const content =
    path === "/" ? <Home lang={lang} navigate={navigate} /> :
    path === "/gallery" ? <Gallery lang={lang} /> :
    (path === "/shop" || path.startsWith("/p/")) ? <Shop lang={lang} /> :
    path === "/contact" ? <Contact lang={lang} /> :
    path === "/cart" ? <Cart lang={lang} /> :
    path === "/materials" ? <MaterialsPage lang={lang} /> :
    path === "/bank-transfer" ? <BankTransferPage lang={lang} /> :

    // regulaminy
    path === "/regulamin" ? <RegulaminPage /> :
    path === "/privacy" ? <PrivacyPage /> :
    path === "/rodo" ? <RodoPage /> :
    path === "/regulamin-en" ? <RegulaminPageEn /> :
    path === "/privacy-en" ? <PrivacyPageEn /> :
    path === "/rodo-en" ? <RodoPageEn /> :

    // ADMIN
    path === "/admin" ? (
      isAdmin
        ? <AdminPanel lang={lang} />
        : <AdminLogin onLogin={() => setIsAdmin(true)} />
    ) :

    <Home lang={lang} navigate={navigate} />;

  return (
    <div className="app-shell">

      {/* HEADER */}
      <header className="navbar">

        {/* LEWA STRONA */}
        <div className="navbar-left">
          <div className="navbar-brand brand-premium">ART TOLCZYK</div>
          <div className="navbar-sub">
            {lang === "pl"
              ? "Obrazy tekstylne, ozdoby ścienne"
              : "Handcrafted textile artworks"}
          </div>
        </div>

        {/* DESKTOP MENU */}
        <nav className="navbar-links">
          <Link to="/">{lang === "pl" ? "O nas" : "About"}</Link>
          <Link to="/gallery">{lang === "pl" ? "Galeria" : "Gallery"}</Link>
          <Link to="/shop">{lang === "pl" ? "Sklep" : "Shop"}</Link>
          <Link to="/materials">
            {lang === "pl" ? "Materiały premium" : "Premium materials"}
          </Link>

          <Link to="/cart">
            {lang === "pl" ? "Koszyk" : "Cart"} {cartCount > 0 && `(${cartCount})`}
          </Link>

          <Link to="/contact">{lang === "pl" ? "Kontakt" : "Contact"}</Link>
        </nav>

        {/* HAMBURGER */}
        <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
          <div className="bar" />
          <div className="bar" />
          <div className="bar" />
        </button>

        {/* JĘZYK */}
        <button
          className="lang-switch"
          onClick={() => setLang(lang === "pl" ? "en" : "pl")}
        >
          {lang === "pl" ? "EN" : "PL"}
        </button>
      </header>

      {/* MOBILE MENU */}
      {menuOpen && (
        <div className="mobile-overlay" onClick={() => setMenuOpen(false)}>
          <div
            className="mobile-overlay-content"
            onClick={(e) => e.stopPropagation()}
          >
            <Link to="/" onClick={() => setMenuOpen(false)}>
              {lang === "pl" ? "O nas" : "About"}
            </Link>
            <Link to="/gallery" onClick={() => setMenuOpen(false)}>
              {lang === "pl" ? "Galeria" : "Gallery"}
            </Link>
            <Link to="/shop" onClick={() => setMenuOpen(false)}>
              {lang === "pl" ? "Sklep" : "Shop"}
            </Link>
            <Link to="/materials" onClick={() => setMenuOpen(false)}>
              {lang === "pl" ? "Materiały premium" : "Premium materials"}
            </Link>
            <Link to="/cart" onClick={() => setMenuOpen(false)}>
              {lang === "pl" ? "Koszyk" : "Cart"} {cartCount > 0 && `(${cartCount})`}
            </Link>
            <Link to="/contact" onClick={() => setMenuOpen(false)}>
              {lang === "pl" ? "Kontakt" : "Contact"}
            </Link>
          </div>
        </div>
      )}

      {content}

      {/* STOPKA */}
      <footer style={{ textAlign: "center", marginTop: "40px", padding: "20px", opacity: 0.7 }}>
        {lang === "pl" ? (
          <>
            <Link to="/regulamin">Regulamin</Link> •{" "}
            <Link to="/privacy">Polityka prywatności</Link> •{" "}
            <Link to="/rodo">RODO</Link>
          </>
        ) : (
          <>
            <Link to="/regulamin-en">Terms & Conditions</Link> •{" "}
            <Link to="/privacy-en">Privacy Policy</Link> •{" "}
            <Link to="/rodo-en">GDPR</Link>
          </>
        )}
      </footer>
    </div>
  );
}
